<template>
	<el-select ref="select" class="filter-item query-item-input" v-model="fuzzyValue" :clearable="clearable" filterable
		:placeholder="placeholder" @change="fuzzyValueChange" @clear="clear" :disabled="disabled"
		@visible-change="val => { if (val && refreshOnOpen) this.init() }">
		<template v-for="(item, index) in optionList">
			<el-option :key="index" :label="item[option.label]" :value="item[valueKey || option.key]"
				:disabled="disabledOptions(item)" v-if="filterOptions(item)">
				<slot :item="item">
					<div v-if="option.optionLeftLabel"
						style="display: flex;justify-content: space-between;align-items: center;">
						<span>{{ item[option.optionLeftLabel] }}</span>
						<span v-if="option.optionRightLabel"
							style="margin-left: 40px;font-size: 12px;color: #909399;">{{ item[option.optionRightLabel]
							}}</span>
					</div>
				</slot>
			</el-option>
		</template>
	</el-select>
</template>

<script>
import request from '@/utils/request'
import setData from './setting.js'
import { dedupeByKey } from './setting.js';

export default {
	name: 'FuzzySelect',
	props: {
		// 双向绑定
		value: {
			required: true,
		},
		valueKey: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: '请选择'
		},
		// 是否可清除
		clearable: {
			type: Boolean,
			default: true
		},
		// 建议选项的标识
		sign: {
			type: String,
			required: true
		},
		// 选项请求参数
		params: {
			type: Object,
			default: () => {
				return {}
			}
		},
		disabledOptions: {
			type: Function,
			default: (row) => {
				return false
			}
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		filterOptions: {
			type: Function,
			default: (row) => {
				return true
			}
		},
		// 去重键
		dedupeKey: {
			type: String,
			default: ''
		},
		// 展开下拉时是否重新拉取最新数据
		refreshOnOpen: {
			type: Boolean,
			default: true
		},
	},
	data() {
		return {
			fuzzyValue: this.value,
			api: setData[this.sign].api,
			option: setData[this.sign].option,
			pageObj: {
				page: 1,
				size: 999
			},
			optionList: [],
		}
	},
	watch: {
		value(newVal) {
			this.fuzzyValue = newVal
		},
		params: {
			handler(newVal, oldVal) {
				if (Object.keys(this.params).some(key => newVal[key] != oldVal[key])) {
					this.init()
				}
			},
			deep: true
		}
	},
	created() {
		this.init()
	},
	methods: {
		// 初始化
		async init() {
			let res = await this.getList()
			if (res.records) {
				this.optionList = res.records || []
			} else {
				this.optionList = res || []
			}
			if (this.dedupeKey) {
				this.optionList = dedupeByKey(this.optionList, this.dedupeKey)
			}
			this.$emit('initData', this.optionList)
		},
		// 获取列表
		getList() {
			let params = { page: this.pageObj.page, size: this.pageObj.size, ...this.params }
			return request({ url: this.api, method: 'get', params })
		},
		// fuzzyValue改变
		fuzzyValueChange(val) {
			let selectedRow = this.optionList.find(item => item[this.valueKey || this.option.key] == val)
			this.$emit("change", this.fuzzyValue, selectedRow)
		},
		clear() {
			this.$emit('clear')
		},
	}
}
</script>

<style></style>
